<template>
  <BaseEdit :onSave="onSave"/>
</template>

<script>
import { mapState } from 'vuex';
import BaseEdit from './BaseEdit';

export default {
  components: {
    BaseEdit,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    async onSave(data) {
      try {
        const job = (await this.$http.post('jobs/', { ...data, employer: this.user.id })).data;
        this.$toast.open({
          message: 'Job created',
          type: 'is-success',
        });
        this.$router.replace({ name: 'job-edit', params: { id: job.id }, passProps: { job } });
      } catch (e) {
        this.$toast.open({
          message: 'Failed to create job',
          type: 'is-danger',
        });
      }
    },
  },

};
</script>
